const TAU = Math.PI * 2;

export const ASTROLABE_BOB = {
  amplitude: 3,
  periodMs: 3_200,
} as const;

export function advanceAstrolabeBobTime(elapsedMs: number, deltaMs: number): number {
  return (elapsedMs + deltaMs) % ASTROLABE_BOB.periodMs;
}

export function getAstrolabeBobOffset(elapsedMs: number): number {
  return -Math.sin((TAU * elapsedMs) / ASTROLABE_BOB.periodMs) * ASTROLABE_BOB.amplitude;
}
